<template>
  <div class="table-wrap">
    <table>
      <thead>
        <tr>
          <th>
            商品信息
          </th>
          <th class=" tx-center">触发通知价格</th>
          <th>状态</th>
          <th class=" tx-center">已收到报价数(未查看数)</th>
          <th>最新报价时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item,index) in items"
          :key="item.id"
        >
          <td class="p-td">
            <div class="p-info">
              <div
                class="img-wrap img-wrapp"
                v-lazy:background-image="item.imgUrl"
              >
              <img
                    	v-if="item.imgUrl"
                    	:src="item.imgUrl"
                    	:preview="index + '_' + item.id"
                  	>
            </div>
              <div class="info">
                <p class=" tx-ellipsis2">{{item.name}}</p>
                <p><span class="title">商品属性：</span> <span class="val">{{item.property}}</span></p>
                <p><span class="title">7/30天销量：</span> <span class="val">{{item.sold7Days}} / {{item.sold30Days}}</span></p>
              </div>
            </div>
          </td>
          <td class=" tx-center">
            {{item.noticePrice}}
          </td>
          <td>
            <span :class="{'tx-primary' :item.status == 1}">{{$dict.receiveStatus[item.status]}}</span>
          </td>
          <td class=" tx-center">
            {{item.allCnt}}({{item.unckeckedCnt}})
          </td>
          <td>
            {{item.lastTime}}
          </td>
          <td>
            <router-link
              class=" tx-primary"
              :to="{name: 'pageOfferDis', query: {id: item.id}}"
            >
              查看详情</router-link>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="page-bottom"
      v-show="last && items.length > 0 && total > 1"
    >
      <p>已经是最后一页了</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["items", "last","total"]
};
</script>

<style lang="less" scoped>
@import "./../../assets/style/config.less";
@import "./../../assets/style/style.less";
.table-wrap {
	background: #fff;
  padding: 15px;
  overflow-x: auto;
  table {
    width: 100%;
    min-width: 1000px;
    border-collapse: collapse;
    font-size: 14px;
    thead {
      th {
        height: 32px;
        padding: 0 10px;
        text-align: left;
        border-bottom: 1px solid @gray-1;
      }
    }
    tbody {
      tr {
        td {
          padding: 10px;
        }
        .p-td {
          max-width: 500px;
        }
      }
      tr:nth-of-type(even) {
        background-color: #f0f0f0;
      }
    }
  }
}
.p-info {
  display: flex;
  .img-wrap {
    margin-right: 15px;
  }
  .info {
    p {
      margin: 0 0 10px;
    }
    .title {
      color: @gray-1;
    }
  }
}
.page-bottom {
  border-top: 1px solid @gray-1;
  p {
    margin: 1.25rem 0;
    text-align: center;
    color: #999;
    font-size: 16px;
  }
}
</style>


